<ng-container *ngIf="percent >= 0">
  <svg [attr.width]="size" [attr.height]="size" transform="rotate(-90)">
    <circle class="all" [attr.cx]="size/2" [attr.cy]="size/2" [attr.r]="radius" fill="none" />
    <circle class="value" [ngClass]="{ exceeded: percent > 100 }" [attr.cx]="size/2" [attr.cy]="size/2" [attr.r]="radius" fill="none" [attr.stroke-dasharray]="dasharray" [attr.stroke-dashoffset]="dashoffset" />
  </svg>
  <span *ngIf="showValue">{{ percent }}%</span>
</ng-container>